import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('Missing Supabase env vars');
}

// Served inside Wovyn (business.bestlifeventures.com/builder/) the builder shares Wovyn's sign-in: same address, same
// stored session, so HQ's Journey map opens signed in. On its own address it keeps its own session as before.
const ON_WOVYN = typeof location !== 'undefined' && location.host === 'business.bestlifeventures.com';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    ...(ON_WOVYN ? { storageKey: 'sb-blv-b2b-auth', flowType: 'pkce' } : {}),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

export const AI_FUNCTION_URL = `${SUPABASE_URL}/functions/v1/biz-builder-ai`;

export async function callAI(action, payload) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');
  const res = await fetch(AI_FUNCTION_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`,
      'apikey': SUPABASE_ANON_KEY
    },
    body: JSON.stringify({ action, payload })
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.error || 'AI call failed');
  return json.data;
}

export async function callEdgeFunction(functionName, payload = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error('Not authenticated');

  const url = `${SUPABASE_URL}/functions/v1/${functionName}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'apikey': SUPABASE_ANON_KEY
    },
    body: JSON.stringify(payload)
  });
  if (!res.ok) {
    let err = `Edge function ${functionName} failed (${res.status})`;
    try {
      const body = await res.json();
      err = body.error || err;
    } catch {}
    throw new Error(err);
  }
  return await res.json();
}
